import React, { memo, useEffect, useState } from 'react';
import PropTypes from "prop-types";
import {useHistory, useLocation} from "react-router-dom";
import { connect } from 'react-redux';
import {Button, Paper} from "@material-ui/core";
import { Markup } from 'interweave';
import { bindActionCreators } from 'redux';
import theme from './style';
import {useConfig} from "../../context/configContext";
import translate from "../../misc/applyTranslation";

const TemplateLogin = (props) => {
  const config = useConfig();
  const classes = theme(config);
  const history = useHistory();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const grandidsession = params.get('grandidsession');

  const {
    children,
    error
  } = props;

  const handleClick = () => {
    window.open(config.company_site, '_blank', 'noopener,noreferrer');
  };

  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (error?.error === "Customer not found for user account" && grandidsession) {
      setShowError(true);
      const params = new URLSearchParams(location.search);
      params.delete('grandidsession');
      history.replace({ search: params.toString() });
    }
  }, [error, grandidsession, history, location.search]);

  if (showError) {
    return (
      <div className={classes.root}>
        <Paper className={classes.paperContainer}>
          <img src={config.logoAuthPath} alt="logo"/>
          <h1>{translate("login", "invalid_account_error_title")}</h1>
          <p>
            <Markup content={translate("login", "invalid_account_error_text")}/>
          </p>
          <Button className={classes.btn} onClick={handleClick}>
            {translate("login", "invalid_account_error_btn")}
          </Button>
        </Paper>
      </div>
    )
  }

  return (
    <div className={classes.root}>
      <div className='container'>
        <div className='logo' />
        <div className='body' >
          {children}
        </div>
      </div>
    </div>
  );
}
TemplateLogin.propTypes = {
  error: PropTypes.string
}
const mapStateToProps = store => ({
  error: store.login.error,
});
const mapDispatchToProps = dispatch =>
  bindActionCreators({
  }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(memo(TemplateLogin));